import "../../../styles/style-prime-paginator-button.css";
import "./inputDate.css";

import { Checkbox, CheckboxProps } from "primereact/checkbox";
import { Chips, ChipsProps } from "primereact/chips";
import { Dropdown, DropdownProps } from "primereact/dropdown";
import { InputNumber, InputNumberProps } from "primereact/inputnumber";
import { InputText, InputTextProps } from "primereact/inputtext";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";
import { MultiSelect, MultiSelectProps } from "primereact/multiselect";
import DatePicker, { DatePickerProps } from "react-date-picker";
import { useControlContext } from "rectangular-forms";

import { InputCurrency } from "../../../components/AdminPaymentValidationStatesSidebar/inputCurrency/inputCurrency";
import MultipleTagInput from "../../../components/MultipleTagInput/MultipleTagInput";
import {
  CalendarReactPrime,
  ChipsReactPrime,
  DivDamPrefix,
  DropdownReactPrime,
  InputNumberReactPrime,
  InputTextReactPrime,
  MultiSelectReactPrime,
} from "./InputTemplateStyles";
import MultipleTagInputOne from "../MultipleTagInputOne/MultipleTagInputOne";
import MultipleTagInputAlfaNum from "../../../components/MultipleTagInput/MultipleTagInputAlfaNum";
import { ERROR_CUSTOMER_DATE } from "../../../utils/valueStaticConstants";

function maxLengthCheck(object) {
  if (object.value.length > object.maxLength)
    object.value = object.value.slice(0, object.maxLength);
}
export function inputUperCaseFn(e) {
  var ss = e.target.selectionStart;
  var se = e.target.selectionEnd;
  e.target.value = e.target.value.toUpperCase();
  e.target.selectionStart = ss;
  e.target.selectionEnd = se;
}

export const inputMaxLengthFn = () => maxLengthCheck(this);

export const onlyDigits = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    // TODO:REFACTORTOTS
    // key = event.clipboardData.getData("text/plain");
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  const regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};

export const onlyDigitsNumbers = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  const regex = /[0-9]/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};
export const onlyDigitsNumbersLetters = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  const regex = /[a-zA-Z0-9]/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};

export const onlyLetterNumberCharacterGuion = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  // eslint-disable-next-line
  const regex = /[A-Z a-z 0-9 \ÁÉÍÓÚÑáéíóúñ-]/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};
export const onlyLetter = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  // eslint-disable-next-line
  const regex = /[A-Z a-z\ÁÉÍÓÚÑáéíóúñ]/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};

export const onlyLetterNumber = (evt: any) => {
  let key: any;
  const theEvent = evt || window.event;
  if (theEvent.type === "paste") {
    key = theEvent.clipboardData.getData("text/plain");
  } else {
    const keyCode = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(keyCode);
  }
  // eslint-disable-next-line
  const regex = /[A-Z a-z 0-9 \ÁÉÍÓÚÑáéíóúñ]/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};
interface IWInputTextProps extends InputTextProps {
  colorBorder?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  haveErros?: boolean;
  isErrorEndpoint?: boolean;
  isSucessEndpoint?: boolean;
}

export const WInputText = (custom: IWInputTextProps) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <InputTextReactPrime
      disabled={disabled}
      colorBorder={custom.colorBorder}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
    >
      <InputText
        value={value || ""}
        disabled={disabled}
        className={
          validationErrors
            ? "p-invalid input-text-react-prime"
            : custom.haveErros
            ? "p-invalid input-text-react-prime"
            : "input-text-react-prime"
        }
        onChange={onChange}
        onBlur={onBlur}
        placeholder={`${
          custom.placeholder ? custom.placeholder : "Placeholder"
        }`}
        {...custom}
      />
    </InputTextReactPrime>
  );
};

export const WInputTextImageRight = (custom: IWInputTextProps) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <InputTextReactPrime
      disabled={disabled}
      colorBorder={custom.colorBorder}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
    >
      <InputText
        value={value || ""}
        disabled={disabled}
        className={
          validationErrors
            ? "p-invalid input-text-react-prime"
            : custom.haveErros || custom.isErrorEndpoint
            ? "p-invalid input-text-react-prime"
            : "input-text-react-prime"
        }
        onChange={onChange}
        onBlur={onBlur}
        placeholder={`${
          custom.placeholder ? custom.placeholder : "Placeholder"
        }`}
        {...custom}
      />
    </InputTextReactPrime>
  );
};
interface IWInputTextDamPrefixProps extends InputTextProps {
  damYear?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  damRegimenId?: string;
}

export const WInputTextDamPrefix = (custom: IWInputTextDamPrefixProps) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <InputTextReactPrime
      disabled={disabled}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
      style={{ cursor: "default" }}
    >
      <div style={{ display: "flex" }}>
        <DivDamPrefix>{`235-${custom.damYear}-${custom.damRegimenId}`}</DivDamPrefix>
        <InputText
          value={value || ""}
          disabled={disabled}
          className={
            validationErrors
              ? "p-invalid input-text-react-prime"
              : "input-text-react-prime"
          }
          onChange={onChange}
          onBlur={onBlur}
          placeholder={`${
            custom.placeholder ? custom.placeholder : "Placeholder"
          }`}
          {...custom}
        />
      </div>
    </InputTextReactPrime>
  );
};

interface IWMultipleTagInput {
  height?: string;
  placeholder?: string;
  TagInputWidth?: boolean;
  width?: string;
}

export const WMultipleTagInput = (custom: IWMultipleTagInput) => {
  const { validationErrors, control } = useControlContext();
  const { value, onChange } = control;

  return (
    <MultipleTagInput
      height={custom.height ? custom.height : "5rem"}
      tagList={value || []}
      onTagListUpdate={onChange}
      hasError={validationErrors}
      {...custom}
    />
  );
};

interface IWMultipleTagInputOne {
  height?: string;
  width?: string;
}

export const WMultipleTagInputOne = (custom: IWMultipleTagInputOne) => {
  const { validationErrors, control } = useControlContext();
  const { value, onChange } = control;

  return (
    <MultipleTagInputOne
      height={custom.height ? custom.height : "5rem"}
      tagList={value || []}
      onTagListUpdate={onChange}
      hasError={validationErrors}
      {...custom}
    />
  );
};

interface IWMultipleTagInputAlphaNum {
  height?: string;
  width?: string;
  alphaNum?: boolean;
  numInvoice?: boolean;
  placeholder?: string;
}
export const WMultipleTagInputAlphaNum = (
  custom: IWMultipleTagInputAlphaNum
) => {
  const { validationErrors, control } = useControlContext();
  const { value, onChange } = control;

  return (
    <MultipleTagInputAlfaNum
      height={custom.height ? custom.height : "5rem"}
      tagList={value || []}
      onTagListUpdate={onChange}
      hasError={validationErrors}
      {...custom}
      alphaNum={custom.alphaNum}
      numInvoice={custom.numInvoice}
    />
  );
};

interface IDropdownProps extends DropdownProps {
  width?: string;
  height?: string;
  fontSize?: string;
}

export const WDropdown = (props: IDropdownProps) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur, load } = control;
  const data = load.data;
  return (
    <DropdownReactPrime
      disabled={disabled}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
    >
      <Dropdown
        value={value || ""}
        disabled={disabled}
        className={
          validationErrors
            ? "p-invalid dropdown-react-prime"
            : "dropdown-react-prime"
        }
        onChange={onChange}
        onBlur={onBlur}
        {...props}
        options={data || props.options}
      />
    </DropdownReactPrime>
  );
};

interface IWMultiSelect extends MultiSelectProps {
  width?: string;
  height?: string;
  fontSize?: string;
}

export const WMultiSelect = (props: IWMultiSelect) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <MultiSelectReactPrime
      disabled={disabled}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
    >
      <div className="multiselect-icon-chip">
        <MultiSelect
          value={value || []}
          disabled={disabled}
          emptyFilterMessage="No existe datos"
          className={
            validationErrors
              ? "p-invalid multiselect-react-prime"
              : "multiselect-react-prime"
          }
          onChange={onChange}
          onBlur={onBlur}
          filter={true}
          display="chip"
          {...props}
        />
      </div>
    </MultiSelectReactPrime>
  );
};

interface IWInputNumber extends InputNumberProps {
  colorBorder?: string;
  width?: string;
  height?: string;
  fontSize?: string;
}

export const WInputNumber = (props: IWInputNumber) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, dirty, onBlur, setValue, markAsDirty } = control;
  let defaultValue = null;
  if (value !== null && value !== undefined) {
    if (typeof value === "number") {
      defaultValue = value;
    } else {
      defaultValue = parseFloat(value);
    }
  }

  return (
    <InputNumberReactPrime
      disabled={disabled}
      colorBorder={props.colorBorder}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
    >
      <InputNumber
        value={defaultValue}
        onBlur={onBlur}
        className={
          validationErrors
            ? "p-invalid multiselect-react-prime"
            : "multiselect-react-prime input-number-react-prime"
        }
        disabled={disabled}
        onValueChange={(e) => {
          const isDirty = value !== e.value;

          if (isDirty && !dirty) {
            markAsDirty.bind(control)();
          }
          setValue.bind(control)(e.value);
        }}
        {...props}
      />
    </InputNumberReactPrime>
  );
};

interface IWChips extends ChipsProps {
  width?: string;
  height?: string;
  fontSize?: string;
}

export const WChips = (custom: IWChips) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <ChipsReactPrime
      disabled={disabled}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
    >
      <Chips
        value={value || []}
        disabled={disabled}
        className={
          validationErrors
            ? "p-invalid input-text-react-prime"
            : "chips-react-prime"
        }
        style={{ width: "100%" }}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={`${custom.placeholder ? custom.placeholder : ""}`}
        {...custom}
      />
    </ChipsReactPrime>
  );
};

interface IWCalendar extends DatePickerProps {
  width?: string;
  height?: string;
  fontSize?: string;
  dateFormat?: string;
}

export const WCalendar = (custom: IWCalendar) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange } = control;
  return (
    <CalendarReactPrime
      disabled={disabled}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
      className={
        validationErrors ? ERROR_CUSTOMER_DATE : "customDatePickerWidth"
      }
    >
      <DatePicker
        className="custom-height-width"
        value={value}
        onChange={onChange}
        clearIcon={null}
        locale={"es-PE"}
        showLeadingZeros={true}
        dayPlaceholder={"dd"}
        monthPlaceholder={"mm"}
        yearPlaceholder={"yyyy"}
        {...custom}
      />
    </CalendarReactPrime>
  );
};

interface IWCheckbox extends CheckboxProps {}

export const WCheckbox = (custom: IWCheckbox) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange } = control;
  return (
    <Checkbox
      checked={value || ""}
      disabled={disabled}
      className={
        validationErrors
          ? "p-invalid input-text-react-prime"
          : "calendar-react-prime"
      }
      onChange={onChange}
      {...custom}
    />
  );
};

interface IWInputTextArea extends InputTextareaProps {
  width?: string;
  height?: string;
  fontSize?: string;
  rows?: number;
  cols?: number;
  maxWidth?: string;
  maxheight?: string;
}

export const WInputTextArea = (custom: IWInputTextArea) => {
  const { validationErrors, control } = useControlContext();
  const { value, disabled, onChange, onBlur } = control;
  return (
    <InputTextReactPrime
      disabled={disabled}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
      maxWidth={custom.maxWidth}
      maxheight={custom.maxheight}
    >
      <InputTextarea
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        className={
          validationErrors
            ? "p-invalid input-text-react-prime"
            : "input-text-react-prime"
        }
        onBlur={onBlur}
        placeholder={`${
          custom.placeholder ? custom.placeholder : "Placeholder"
        }`}
        {...custom}
      />
    </InputTextReactPrime>
  );
};

interface IWInputCurrency {
  colorBorder?: string;
  width?: string;
  height?: string;
  fontSize?: string;

  maxLength?: number;
  style?: any;
  locale: string;
  currency: any;
  haveErros?: boolean;
  placeholder?: string;
}

export const WInputCurrency = (custom: IWInputCurrency) => {
  const { validationErrors, control } = useControlContext();
  const { disabled, onChange, onBlur } = control;
  return (
    <InputTextReactPrime
      disabled={disabled}
      colorBorder={custom.colorBorder}
      width={custom.width}
      height={custom.height}
      fontSize={custom.fontSize}
    >
      <InputCurrency
        disabled={disabled}
        maxLength={custom.maxLength}
        style={custom.style}
        locale={custom.locale}
        currency={custom.currency}
        className={
          validationErrors
            ? "p-invalid input-text-react-prime"
            : custom.haveErros
            ? "p-invalid input-text-react-prime"
            : "input-text-react-prime"
        }
        onChange={onChange}
        onBlur={onBlur}
        placeholder={`${
          custom.placeholder ? custom.placeholder : "Placeholder"
        }`}
        {...custom}
      />
    </InputTextReactPrime>
  );
};
